import AnchorLink from 'components/AnchorLink'
import { Link } from 'gatsby'
import useNestedDocuments from 'hooks/useNestedDocuments'
import PropTypes from 'prop-types'
import React from 'react'
import getFinalUrl from 'utils/getFinalUrl'
import { withPrefix, withoutPrefix } from 'utils/prefix'
import { useLocation } from '../LocationContext/LocationContext'
import joinPath from 'utils/joinPath'

Clickable.propTypes = {
	target: PropTypes.string,
	to: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ pathname: PropTypes.string })]),
}
export default function Clickable({ children, className, items, onClick, style, target, to, download, ...props }) {
	const url = useFinalUrl(to?.pathname || to, items)
	const commonProps = { children, className, onClick, style, target }

	const handleClick = e => {
		onClick?.(e)

		// Fire a 'hashchange' event after URL changes
		setTimeout(() => {
			const hashChangeEvent = new Event('hashchange')
			window.dispatchEvent(hashChangeEvent)
		})
	}

	if (download) return <a {...commonProps} href={url} download={download} />

	if (/^http/.test(url) || target === '_blank')
		return <a {...commonProps} href={url} onClick={handleClick} rel='noopener noreferrer' target='_blank' />

	if (/^[./]/.test(url)) return <Link {...commonProps} state={props.state} to={url} onClick={handleClick} />

	if (/^#/.test(url)) return <AnchorLink {...props} {...commonProps} to={url} onClick={handleClick} />

	if (props.onClick || props.type)
		return <button type={props.type || 'button'} {...props} {...commonProps} onClick={handleClick} />

	return <a {...commonProps} href={url} />
}

const useFinalUrl = (baseUrl, children) => {
	const location = useLocation()

	// Convert relative path (e.g. "./" or "../") to absolute path to identify nested documents
	let url = baseUrl?.startsWith('.') ? joinPath(location.pathname, baseUrl) : baseUrl

	const nestedDocuments = useNestedDocuments(withPrefix(url))

	if (!/^[./]/.test(baseUrl)) {
		return baseUrl
	}

	url = withoutPrefix(url)

	if (!children?.length && !nestedDocuments?.length) return url

	if (url.startsWith('/sdk')) return getFinalUrl({ items: children, url, virtual: !!children })

	const [parent, ...queriedChildren] = nestedDocuments

	return getFinalUrl({ ...parent, items: queriedChildren })
}
